import { FC } from "react";
import testimonial1 from "../../Assets/TalentOnDemand/testimonial1.png";
import testimonial2 from "../../Assets/TalentOnDemand/testimonial2.png";

const testimonials = [
    {
        img: testimonial1,
        text: `“Salesmrkt saved me so much time and effort. It was great having candidates create a profile that included WAY more information than just a resume can provide. It acted as a first-round interview. I am so happy with Nicole. She has been amazing!”`,
        name: "Erica Koines",
        title: "Director of Wholesale, J.McLaughlin",
    },
    {
        img: testimonial2,
        text: `“Salesmrkt was super user-friendly and very easy to navigate. The platform walked me through each section and notified me if I needed to complete anything missing on my”`,
        name: "Nicole Mendoza",
        title: "Applicant/Wholesale Assistant",
    },
];

const TalentOnDemandFeaturesTestimonials: FC = () => {
    return (
        <section className="w-full bg-white py-10 px-10">
            <div className="w-full max-w-[1400px] mx-auto flex flex-col gap-16 items-center text-black">
                <div className="text-3xl md:text-5xl font-semibold text-center">
                    Real-World Impact
                </div>

                <div className="grid md:grid-cols-2 gap-16 lg:gap-10 mt-16 w-full max-w-[1200px]">
                    {testimonials.map((item, index) => (
                        <div
                            key={index}
                            className="border border-brand-green rounded-xl p-8 text-center relative flex flex-col"
                        >
                            <div className="absolute -top-12 left-1/2 transform -translate-x-1/2">
                                <div className="w-[96px] h-[96px] rounded-full border-4 border-white shadow-md overflow-hidden bg-brand-green">
                                    <img src={item.img} alt={item.name} className="w-full h-full object-cover" />
                                </div>
                            </div>
                            <p className="italic text-gray-800 mt-16 mb-5 ">{item.text}</p>
                            <div className="font-semibold mt-auto text-lg">{item.name}</div>
                            <div className="text-sm text-gray-600">{item.title}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default TalentOnDemandFeaturesTestimonials;
